import React from 'react';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import { ReactComponent as BankIcon } from '../../../../assets/icons/svg/colored-icons/ic-colored-bank-placeholder.svg';
import { getBase64Image } from '../../../../helpers/image.helpers';
import { LinkedAccount } from '../../hooks/useLinkedAccounts';

interface SyncedCardProps {
  card: LinkedAccount;
  selected: boolean;
  onClick: (card: LinkedAccount) => void;
  isLoading: boolean;
}

const SyncedCard = (props: SyncedCardProps) => {
  const { card, selected, onClick, isLoading } = props;
  const { t } = useTranslation();

  return (
    <button
      type='button'
      key={card.externalId}
      onClick={() => onClick(card)}
      className={`flex flex-row gap-[8px] w-[244px] h-[52px] py-[8px] pr-[26px] pl-[12px] items-center bg-bw00 hover:bg-bw01 border-[1px] rounded-[4px] cursor-pointer ${selected ? 'border-action03' : 'border-bw03'}`}
    >
      {isLoading ? (
        <>
          <Skeleton circle height='32px' width='32px' />
          <div className='flex flex-col'>
            <Skeleton height='14px' width='144px' style={{ lineHeight: 'unset' }} />
            <Skeleton height='10px' width='102px' style={{ lineHeight: 'unset' }} />
          </div>
        </>
      ) : (
        <div className='flex flex-row gap-[8px] items-center'>
          {card.institutionLogo ? (
            <div className='rounded-full border-[1px] border-bw04 h-[32px] w-[32px] p-[4px] flex flex-col'>
              <img src={getBase64Image(card.institutionLogo)} alt={card.bankName} />
            </div>
          ) : (
            <BankIcon className='w-[32px] h-[32px]' />
          )}
          <div className='flex flex-col items-baseline'>
            <div className='font-metricRSemibold leading-[146%] text-sm text-left text-bw08'>{card.bankName}</div>
            {card.expired ? (
              <div className='font-metricR text-xxs text-red02'>
                {t('TRANSACTIONS_FACELIFT.SYNC_CARD.LINK_EXPIRED')}
              </div>
            ) : (
              <div className='font-metricR text-xxs text-bw07'>
                {t('TRANSACTIONS_FACELIFT.SYNC_CARD.CREDIT_CARD', { cardNumber: card.cardNumber })}
              </div>
            )}
          </div>
        </div>
      )}
    </button>
  );
};

export default SyncedCard;
